import { Spaces } from '../../../../api/api-spaces';
import { Listings } from '../../../../api/api-listings';
import * as types from '../constants/action-types';
import { get } from 'lodash';


export function fetchSpacesRequest () {
  return {
    type: types.SPACES_FETCH_REQUEST
  };
}

export function fetchSpacesSuccess (data) {
  return {
    type: types.SPACES_FETCH_SUCCESS,
    data
  };
}

function fetchSpacesFailure (fetchError) {
  return {
    type: types.SPACES_FETCH_FAILURE,
    fetchError
  };
}

function clearSpacesData () {
  return {
    type: types.SPACES_CLEAR_STORE,
    data: []
  };
}

export function fetchOwnerSpacesInfo (query, accessToken) {
  return dispatch => {
    dispatch(fetchSpacesRequest());

    return Spaces.read(query, accessToken, (response) => {
      if (200 === response.statusCode) {
        const spaces = get(response, 'spaces', []);
        return dispatch(fetchSpacesSuccess(spaces));
      }

      const fetchError = get(response, 'error', '');
      dispatch(fetchSpacesFailure(fetchError));
    });
  };
}

export function clearSpacesStore () {
  return dispatch => {
    dispatch(clearSpacesData());
  };
}


// Call to get all of ACTIVATED host spaces
export const fetchActiveSpaces = (SSOid, accessToken) => {
  const query = `owner/${SSOid}/status/ACTIVATED/?full=true`;

  return dispatch => {
    dispatch(fetchSpacesRequest());
    // start fetching spaces by getting all user listings
    const fetchListings = () => {
      return new Promise((resolveListings, rejectListings) => {
        return Listings.queryListings(query, (response) => {
          if (200 !== response.statusCode) {
            dispatch(fetchSpacesFailure(response.error));
            return rejectListings();
          }
          const listings = _.get(response, ['listings'], []);
          return resolveListings(listings);
        });
      });
    };

    // get spaced ids from listings and string ids for query
    const getSpaceIds = (listings) => {
      const uniqueSpaces = _.uniqBy(listings, 'parentSpaceId');
      const stringIds = (array) => array.map(item => `ids=${item}`).join('&');
      return stringIds(uniqueSpaces.map((space) => space.parentSpaceId));
    };

    // start of Promise call chains
    fetchListings()
      .then(getSpaceIds)
      .then((joinedIds) => dispatch(fetchOwnerSpacesInfo(`?${joinedIds}`, accessToken)));
  };
};

export function updateSpace (spaceId, spaceObj) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { auth } = getState();
      dispatch({ type: types.SPACE_UPDATE_REQUEST });

      Spaces.update(spaceId, auth.accessToken, spaceObj, (response) => {
        if (response.error) {
          return reject(dispatch({
            type: types.SPACE_UPDATE_FAILURE,
            error: response.error
          }));
        }

        return resolve(dispatch({
          type: types.SPACE_UPDATE_SUCCESS,
          profile: response.profile
        }));
      });
    });
  };
}
